<template>
  <div class="container">
    <el-card>
      <div slot="header">模板管理</div>
      <div style="height: 100%">
        <div class="btns">
          <el-button
            @click="editTemplate"
            icon="el-icon-edit"
            size="small"
            style="background-color: #1abc9c !important"
            >修改</el-button
          >
        </div>
        <div class="tableStyle">
          <el-table
            :data="tableData"
            style="width: fit-content"
            height="93%"
            highlight-current-row
            @current-change="handleCurrentChange"
          >
            <el-table-column
              prop="name"
              label="名称"
              width="200"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="filePath"
              label="路径"
              width="600"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-card>

    <el-dialog title="编辑模板" :visible.sync="addTemplateDialog" width="800px">
      <div>
        <el-form :model="addForm" label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="addForm.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="路径">
            <el-input v-model="addForm.filePath"></el-input>
          </el-form-item>
        </el-form>
        <ExcelUpload
          ref="excelUploadRef"
          @onSuccess="UploadSuccess"
        ></ExcelUpload>
      </div>
      <div slot="footer">
        <el-button @click="addTemplateDialog = false">取 消</el-button>
        <el-button type="primary" @click="save"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { translateObjectEmptyAttributeToNull } from '../../untils/func';
import {
  selectList,
  save,
  detail,
} from '../../api/property/basicExcelTemplate';
import ExcelUpload from '../customComponent/ExcelUpload.vue';
export default {
  components: {
    ExcelUpload,
  },
  data() {
    return {
      currentRow: null,
      tableData: [],
      total: 0,
      loading: true,
      addTemplateDialog: false,
      addForm: {},
    };
  },

  created() {
    this.init();
  },
  mounted() {},
  watch: {},
  methods: {
    async init() {
      await this.handleQuery();
    },
    async handleQuery() {
      this.loading = true;
      let param = this.queryParams;
      param = translateObjectEmptyAttributeToNull(param);
      const response = await selectList(param).then();
      this.tableData = response.data;
      console.log(this.tableData);
      this.total = response.total;
      this.loading = false;
    },

    async UploadSuccess(data) {
      // console.log(data);
      this.addForm.filePath = data;
      // await this.handleQuery();
    },

    async save() {
      await save(this.addForm).then();
      await this.handleQuery();
      this.msgSuccess('保存成功');
      this.addTemplateDialog = false;
    },
    // 打开修改对话框
    async editTemplate() {
      if (this.currentRow == null) {
        this.$message.error('请先选择某条数据！');
      } else {
        await this.viewDetail();
        this.addTemplateDialog = true;
        this.$nextTick(() => {
          this.$refs.excelUploadRef.clearFilelist();
        });
      }
    },

    async viewDetail() {
      const res = await detail({ id: this.currentRow }).then();
      this.addForm = res.data;
    },
    // 单选表格某一行
    handleCurrentChange(val) {
      this.currentRow = val.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px;
  height: 100%;
}
/deep/ .el-card__header {
  background-color: var(--secondColor) !important;
  color: var(--whiteColor);
}

.searchTag {
  width: 200px;
}

.tableStyle {
  margin-top: 10px;
  height: calc(100% - 50px);
}
// @media screen and (max-width: 1340px) {
//   .tableStyle {
//     height: calc(100% - 80px);
//   }
// }
</style>
